module.exports = __webpack_public_path__ + "static/21-03-25_18-50-59_4755-1fa50615a2f34279c0350c70ea74de49.jpg";